import type { ReactNode } from "react";
import { useIsMobile } from "@/hooks/use-is-mobile";
import { PageUnavailable } from "@/components/layout/page-unavailable";

/**
 * Renders its page on the phone view only. On desktop it shows the "page
 * unavailable" screen, the same as an address that no longer exists.
 *
 * Used for Inbox and Goals (2026-09-26, Kenneth): removed from desktop because
 * Tasks, Issues and the notification bell replaced them, but Inbox is still a
 * tab in the phone view and opens Goals.
 */
export function PhoneOnly({ children }: { children: ReactNode }) {
  return useIsMobile() ? <>{children}</> : <PageUnavailable />;
}
